import React, { useRef, useState, useEffect } from "react";
import "./Process.css";

const steps = [
    {
        number: "01",
        title: "Discover the problem",
        description: "We start by understanding your business, your bottlenecks, and what you are trying to achieve."
    },
    {
        number: "02",
        title: "Design the solution",
        description: "We propose a clear, practical solution—whether it's a new website, an automated workflow, or a custom tool."
    },
    {
        number: "03",
        title: "Build and implement",
        description: "We build the solution quickly and integrate it into your existing operations with minimal disruption."
    },
    {
        number: "04",
        title: "Train and support",
        description: "We ensure you and your team know how to use the new systems and provide ongoing support if needed."
    }
];

export default function Process() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        if (targetRef.current) observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "Process hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="process">
            <h2 className="title">How We Help</h2>
            <div className="process-grid">
                {steps.map((step) => (
                    <article key={step.number} className="process-card">
                        <span className="step-number">{step.number}</span>
                        <h3>{step.title}</h3>
                        <p>{step.description}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}
